import React, {useEffect, useState} from 'react';
import api from "../../api";
import CompanyStatus from "../User/CompanyStatus";
import { useUser } from '../../context/UserContext';
import {useNotification} from '../../context/NotificationContext';
import PopupVendorRequestForm from '../popups/PopupVendorRequestForm';

const VendorWithImage = ({vendor, onShowPopup, styleClass, showRequestHelpButton = false, onRequestHelp}) => {
    const { isAuthenticated } = useUser();
    const {showNotification} = useNotification();

    const [isRequestFormOpen, setIsRequestFormOpen] = useState(false);

    const handleOpenRequestForm = (e) => {
        e.stopPropagation();
        setIsRequestFormOpen(true);
    };

    const handleCloseRequestForm = () => {
        setIsRequestFormOpen(false);
    };

    const truncateDescription = (desc, length) => {
        if (desc && desc.length > length) {
            return desc.substring(0, length) + '...';
        }
        return desc;
    };

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [isFavorite, setIsFavorite] = useState(vendor.is_favorite);

    const formatPhoneNumber = (phoneNumber) => {
        let cleaned = ('' + phoneNumber).replace(/\D/g, '');
        if (!cleaned.startsWith('1')) {
            cleaned = '1' + cleaned;
        }
        const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
        }
        return phoneNumber;
    };

    const formattedAddress = vendor.address
        ? `${vendor.address.street_address}, ${vendor.address.city.name}, ${vendor.address.state.name}`
        : 'Address not available';

    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(formattedAddress)}`;

    useEffect(() => {
        const checkFavoriteStatus = async () => {
            const token = localStorage.getItem('authToken');
            if (!token || !vendor || !vendor.vendor_id) return;
            try {
                const config = { headers: { 'Authorization': `Bearer ${token}` } };
                const response = await api.get(`/check-favorite-vendor/${vendor.vendor_id}/`, config);
                setIsFavorite(response.data.is_favorite);
            } catch (error) {
                console.error('Error checking favorite status:', error);
            }
        };

        if (isAuthenticated) {
            checkFavoriteStatus();
        } else {
            setIsFavorite(false);
        }
    }, [vendor.vendor_id, isAuthenticated]);

    const getLogoUrl = (logo) => {
        if (logo && !logo.startsWith('http://') && !logo.startsWith('https://')) {
            return `${baseUrl}${logo}`;
        }
        return logo;
    };

    const handleToggleFavorites = async (e) => {
        e.stopPropagation();
        if (!isAuthenticated) {
            showNotification("Login Required", "Please log in to manage favorites.", null, "warning");
            return;
        }
        const endpoint = isFavorite ? '/remove-favorite-vendor/' : '/add-favorite-vendor/';
        try {
            await api.post(endpoint, { vendor_id: vendor.vendor_id });
            setIsFavorite(!isFavorite);
        } catch (error) {
            console.error('Error toggling favorite:', error);
        }
    };

    // --- НАЧАЛО: ПРАВИЛЬНАЯ ЛОГИКА ---
    // Проверяем ID ВЛАДЕЛЬЦА КАРТОЧКИ (vendor.user)
    const lawUserId = parseInt(process.env.REACT_APP_LAW_LAW_USER_ID, 10);
    const showPhoneNumber = vendor.user !== lawUserId;
    // --- КОНЕЦ: ПРАВИЛЬНАЯ ЛОГИКА ---


    return (
        <>
            <div
                className={`vendor ${styleClass}`}
                onClick={() => onShowPopup(vendor.vendor_id, 'vendor')}
                style={{
                    background: styleClass === 'vendor-day' && vendor.background_image
                        ? `linear-gradient(rgba(44, 65, 87, 0.7), rgba(44, 65, 87, 0.7)), url(${getLogoUrl(vendor.background_image)})`
                        : ``
                }}
            >
                <div className="container">
                    <div className="justify">
                        {styleClass === 'vendor-day' && vendor.logo && (
                            <div className="vendor__logo js--show-popup">
                                <picture>
                                    <source type="image/webp" srcSet={`${getLogoUrl(vendor.logo)} 1x, ${getLogoUrl(vendor.logo)} 2x`}/>
                                    <source type="image/jpg" srcSet={`${getLogoUrl(vendor.logo)} 1x, ${getLogoUrl(vendor.logo)} 2x`}/>
                                    <img srcSet={`${getLogoUrl(vendor.logo)} 1x, ${getLogoUrl(vendor.logo)} 2x`} alt={vendor.name}/>
                                </picture>
                            </div>
                        )}
                        <div className="vendor__data js--show-popup">
                            <div className="vendor__header">
                                <h4 className="vendor__name">{vendor.name}</h4>
                                <button
                                    className={`favorites ${isFavorite ? 'added' : ''}`}
                                    onClick={handleToggleFavorites}
                                >
                                    <svg>
                                        <path fillRule="evenodd" clipRule="evenodd"
                                              d="M1.58733 3.10072C3.70393 0.940385 7.13582 0.940385 9.25246 3.10072L10.0323 3.89665L10.7475 3.16683C12.8641 1.0065 16.296 1.0065 18.4127 3.16683C20.5293 5.32717 20.5292 8.82998 18.4127 10.9904L10.4695 19.0901C10.4418 19.1184 10.5003 19.068 10.4695 19.0901C10.2068 19.2849 9.79324 19.2991 9.5566 19.0576L1.58757 10.9239C-0.52903 8.76353 -0.529268 5.26111 1.58733 3.10072Z"></path>
                                    </svg>
                                </button>
                                <CompanyStatus status={vendor.status}/>
                            </div>
                            <p className="vendor__description">{truncateDescription(vendor.description, 150)}</p>
                        </div>
                        <div className="vendor__contacts">
                            <div className="row">
                                <a className="vendor__link" href={googleMapsUrl} target="_blank" rel="noopener noreferrer">{formattedAddress}</a>
                                <span className="vendor__label">Address</span>
                            </div>

                            {/* Override in UserProfile to show Request Legal Help */}
                            {showRequestHelpButton ? (
                                <div className="row">
                                    <button
                                        className="button button-black vendor__button_request_consultation"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (typeof onRequestHelp === 'function') {
                                                onRequestHelp();
                                            } else if (typeof onShowPopup === 'function') {
                                                onShowPopup(vendor.vendor_id, 'vendor', 'edit-profile');
                                            }
                                        }}
                                        type="button"
                                    >
                                        Edit Profile
                                    </button>
                                </div>
                            ) : (
                                // Default behavior outside of UserProfile
                                showPhoneNumber ? (
                                    <div className="row">
                                        <a className="vendor__link" href={`tel:${vendor.phone_number}`}>{formatPhoneNumber(vendor.phone_number)}</a>
                                        <span className="vendor__label">Phone</span>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <button
                                            className="button button-black vendor__button_request_consultation"
                                            onClick={handleOpenRequestForm}
                                            type="button"
                                        >
                                            Request Service
                                        </button>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {isRequestFormOpen && (
                 <PopupVendorRequestForm
                    isOpen={isRequestFormOpen}
                    onClose={handleCloseRequestForm}
                    initialStateId={vendor?.address?.state?.state_id}
                    initialCityId={vendor?.address?.city?.city_id}
                    vendorId={vendor.vendor_id}
                />
            )}
        </>
    );
};

export default VendorWithImage;
